module.exports = __webpack_public_path__ + "static/media/logo.803bf6f7.png";